const Veterinarios = () => <div><h3>🩺 Gestión de Veterinarios</h3></div>;
export default Veterinarios;